import { Fragment } from "react";
import PropTypes from "prop-types";
import Notification from "components/Notification";

import AuthNotifications, { authNotificationCodes } from "./notifications/auth";
import DefaultNotifications, { defaultNotificationCodes } from "./notifications/default";
import MyAccountNotifications, { myAccountNotificationCodes } from "./notifications/myAccount";

/**
 * Notification Manager
 * @return {Node} Returns Notification component
 */
const NotificationManager = ({ code, identifier, detail, notificationData }) => {
    const props = { code, identifier, detail, notificationData };

    if (code && defaultNotificationCodes.has(code)) {
        return <DefaultNotifications {...props} />;
    }

    if (code && authNotificationCodes.has(code)) {
        return <AuthNotifications {...props} />;
    }

    if (code && myAccountNotificationCodes.has(code)) {
        return <MyAccountNotifications {...props} />;
    }

    return (
        <Notification
            identifier={identifier}
            title="Warning"
            text={
                <Fragment>
                    <strong>{code}</strong> - This is the message missing Notification case!
                    {!!detail && (
                        <Fragment>
                            <br />
                            {detail}
                        </Fragment>
                    )}
                </Fragment>
            }
            type="warning"
        />
    );
};

NotificationManager.defaultProps = {
    code: null,
    identifier: null,
    detail: null,
    notificationData: null,
};

NotificationManager.propTypes = {
    code: PropTypes.string,
    identifier: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.string,
};

export default NotificationManager;
